import { render, staticRenderFns } from "./organizationSvg.vue?vue&type=template&id=07c9b2ce&"
import script from "./organizationSvg.vue?vue&type=script&lang=js&"
export * from "./organizationSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports